import {
  type PluginColumnsHook,
  definePluginColumnsHook,
} from "@features/plugins/pluginColumnsHook";
import {
  type PluginReportDataMappingHook,
  definePluginReportDataMappingHook,
} from "@features/plugins/pluginReportDataMappingHook";
import type { CsvSchema } from "@utils/csv";

/** Loose legacy host row — `maps.js` is the source of truth for host keys. */
type LegacyHostRow = Record<string, unknown>;

export type MappedReportHooks = {
  columns: PluginColumnsHook<CsvSchema<LegacyHostRow>[number]>;
  dataMapping: PluginReportDataMappingHook<LegacyHostRow>;
};

/**
 * Paired columns + data-mapping hooks for a **legacy** report that invents
 * camelCase rows in `maps.js`. Prefer columns-only (or API consumer shape) for
 * new reports. When using this pair, plugins that add a wire-backed column must
 * contribute to both `report.columns` and `report.dataMapping`. Host overwrite
 * of mapped fields is enforced at `apply` time.
 */
function defineMappedReportHooks(config: { name: string }): MappedReportHooks {
  return {
    columns: definePluginColumnsHook<CsvSchema<LegacyHostRow>[number]>({
      name: `reports.${config.name}.columns`,
    }),
    dataMapping: definePluginReportDataMappingHook<LegacyHostRow>({
      name: `reports.${config.name}.dataMapping`,
    }),
  };
}

export const orderWindowDetailReport = defineMappedReportHooks({
  name: "orderWindowDetail",
});

export const shippedOrdersReport = defineMappedReportHooks({
  name: "shippedOrders",
});

export const itemListReport = defineMappedReportHooks({
  name: "itemList",
});
